var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useContext } from 'react';
import { translate } from '@utils/i18n';
import { Controller, useFormContext } from 'react-hook-form';
import { TimeZoneContext } from '@contexts/timezone-context';
import { transformDayJstoDate } from '@utils/dateUtils';
import { dateClient } from '@utils/date-client';
import Duration from './duration';
import AssigneeMultiSelect from '@components/Multiselects/AssigneeMultiselect';
import { TenantContext } from '@contexts/tenant-context';
import { EditGenericEventModalContext } from '../../context/EditGenericEventModalContext';
import { Button } from '@ui';
import TimeZoneDropdown from '@components/Dropdowns/TimeZoneDropdown';
import { InlineEdit } from '@components/v2/InlineEdit';
function DetailsSection() {
    var _a;
    const namespace = 'features.modals.edit_generic_event_modal.details_section';
    const { tenant } = useContext(TenantContext);
    const { timeZoneList, handleModalSave } = useContext(EditGenericEventModalContext);
    const { timeZonesMapping } = useContext(TimeZoneContext);
    const { control, watch, getValues, trigger, formState: { errors } } = useFormContext();
    const formValues = watch();
    const handleDateChange = (field, newDate) => __awaiter(this, void 0, void 0, function* () {
        const date = dateClient(newDate)
            .tz(timeZonesMapping[formValues.timeZone])
            .year(newDate.getFullYear())
            .month(newDate.getMonth())
            .date(newDate.getDate())
            .hour(field.value.hour())
            .minute(field.value.minute())
            .second(field.value.second())
            .millisecond(field.value.millisecond());
        field.onChange(date);
        const isValid = yield trigger();
        if (isValid) {
            handleModalSave({ genericEvent: getValues() });
        }
    });
    const handleTimeChange = (field, newTime) => __awaiter(this, void 0, void 0, function* () {
        const date = dateClient(field.value)
            .tz(timeZonesMapping[formValues.timeZone])
            .year(field.value.year())
            .month(field.value.month())
            .date(field.value.date())
            .hour(newTime.getHours())
            .minute(newTime.getMinutes())
            .second(newTime.getSeconds())
            .millisecond(newTime.getMilliseconds());
        field.onChange(date);
        const isValid = yield trigger();
        if (isValid) {
            handleModalSave({ genericEvent: getValues() });
        }
    });
    const handleChange = (field, value) => __awaiter(this, void 0, void 0, function* () {
        const oldValue = field.value;
        if (value === oldValue) {
            return;
        }
        field.onChange(value);
        const isValid = yield trigger();
        if (isValid) {
            handleModalSave({ genericEvent: getValues() });
        }
    });
    return (React.createElement("div", { className: "detailsSection", id: "detailsSection" },
        React.createElement(Controller, { name: "technicianIds", control: control, rules: { required: translate('validations.technicians', { namespace }) }, render: ({ field }) => (React.createElement("div", { className: "info-container" },
                React.createElement("div", { className: "info-row" },
                    React.createElement("label", { className: "qmb-label--required info-key" }, translate('assigned_to', { namespace })),
                    React.createElement(AssigneeMultiSelect
                    // eslint-disable-next-line react/style-prop-object
                    , { 
                        // eslint-disable-next-line react/style-prop-object
                        style: "inline-edit", skipUnassigned: true, onlyTechnicians: true, hasSelectAll: true, teamIds: null, selectedTechnicianIds: field.value, selectedSubcontractorIds: [], onTechChange: (selections) => handleChange(field, selections), onSubChange: () => { } })),
                errors.technicianIds && React.createElement("div", { className: "info-error" }, errors.technicianIds.message))) }),
        ((_a = tenant === null || tenant === void 0 ? void 0 : tenant.flags) === null || _a === void 0 ? void 0 : _a.hasMultiTimezone) && (React.createElement(Controller, { name: "timeZone", control: control, render: ({ field }) => {
                return (React.createElement("div", { className: "info-container" },
                    React.createElement("div", { className: "info-row" },
                        React.createElement("label", { className: "qmb-label info-key" }, translate('time_zone', { namespace })),
                        React.createElement("div", { className: "info-value" },
                            React.createElement(TimeZoneDropdown, { variant: "inline-edit", timeZoneList: timeZoneList, selectedValue: field.value, onChange: (value) => handleChange(field, value) })))));
            } })),
        React.createElement("div", { className: "info-container" },
            React.createElement("div", { className: "info-row" },
                React.createElement("span", { className: "qmb-label--required info-key" }, translate('when', { namespace })),
                React.createElement(Controller, { name: "start", control: control, render: ({ field }) => (React.createElement(InlineEdit, { variant: "date", className: "info-value", id: field.name, dateValue: transformDayJstoDate(field.value), onDateChange: (date) => handleDateChange(field, date) })) }),
                React.createElement("span", null, "@"),
                React.createElement(Controller, { name: "start", control: control, render: ({ field }) => (React.createElement(InlineEdit, { variant: "time", className: "info-value", id: field.name, dateValue: transformDayJstoDate(formValues.allDay ? field.value.startOf('day') : field.value), onTimeChange: (date) => handleTimeChange(field, date), disableEdit: formValues.allDay })) })),
            React.createElement("div", { className: "info-row" },
                React.createElement("span", { className: "qmb-label info-key" }),
                React.createElement("span", null, translate('for', { namespace })),
                React.createElement(Duration, null))),
        formValues.allDay ? (React.createElement("div", { className: "info-container" },
            React.createElement("div", { className: "info-row" },
                React.createElement(Controller, { name: "end", control: control, render: ({ field }) => (React.createElement(React.Fragment, null,
                        React.createElement("span", { className: "qmb-label--required info-key" }, translate('end_date', { namespace })),
                        React.createElement(InlineEdit, { variant: "date", className: "info-value", id: field.name, dateValue: transformDayJstoDate(field.value), onDateChange: (date) => handleDateChange(field, date) }))) }),
                React.createElement(Controller, { name: "allDay", control: control, render: ({ field }) => (React.createElement(Button, { onClick: () => handleChange(field, false) },
                        React.createElement("i", { className: "fa-light fa-trash-can" }))) })))) : (React.createElement(Controller, { name: "allDay", control: control, render: ({ field }) => (React.createElement("div", { className: "info-row" },
                React.createElement("span", { className: "info-key" }),
                React.createElement(Button, { variant: "highlighted", onClick: () => handleChange(field, true) }, translate('add_end_date', { namespace })))) }))));
}
export default DetailsSection;
